import { translations } from '../translations'
import { cap } from '.'
const language = cap.language.state || 'IT'
const t = translations[language]

export default [
  {
    id: 'plane',
    name: t.aereo,
    icon: 'plane',
    filters: [
      { name: t.price, code: 'p' },
      { name: t.time, code: 'o' },
      { name: t.duration, code: 'd' },
      { name: t.bestBuy, code: 'bb' }
    ]
  },
  {
    id: 'train',
    name: t.treno,
    icon: 'train',
    filters: [
      { name: t.price, code: 'p' },
      { name: t.time, code: 'o' },
      { name: t.duration, code: 'd' },
      { name: t.bestBuy, code: 'bb' }
    ]
  },
  {
    id: 'hotel',
    name: t.hotel,
    icon: 'hotel',
    filters: [
      { name: t.price, code: 'p' },
      { name: t.distance, code: 'd' },
      { name: t.bestBuy, code: 'bb' }
    ]
  },
  {
    id: 'car',
    name: t.auto,
    icon: 'car',
    filters: [{ name: t.bestBuy, code: 'bb' }]
  }
]
